/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'goal-content.goal-about-content.description-edit-button': 'Rediger',
  'project-actions.project-content-about.edit-description-error-description':
    'Der gik noget galt. Prøv igen om et par minutter.',
  'project-content.project-content-about.edit-description-error-title': 'Projektbeskrivelsen kunne ikke redigeres',
  'project-content.project-content-about.the-measure-placeholder':
    'Beskriv, hvordan succes ser ud, og hvad du håber at opnå.',
  'project-content.project-content-about.the-measure-title': 'Sådan ved vi, at vi har succes',
  'project-content.project-content-about.the-what-placeholder': 'Beskriv dette projekt og det arbejde, det indebærer.',
  'project-content.project-content-about.the-what-title': 'Det, vi laver',
  'project-content.project-content-about.the-why-placeholder':
    'Forklar, hvorfor dette arbejde finder sted, og grundene til det.',
  'project-content.project-content-about.the-why-title': 'Grunden til, at vi gør det',
  'project-content.project-content-update-date.edited': '(redigeret)',
  'project-content.project-content-update-date.edited-tooltip': 'Redigeret den {date}',
  'project-content.project-content-update-date.last-edited-by': '(senest redigeret af {name})',
  'project-content.project-content-updates.add-update': 'Tilføj opdatering',
  'project-content.project-content-updates.archived': 'Arkiveret',
  'project-content.project-content-updates.at-risk': 'I farezonen',
  'project-content.project-content-updates.cancelled': 'Annulleret',
  'project-content.project-content-updates.completed': 'Afsluttet 🎉',
  'project-content.project-content-updates.date-changed': 'Dato ændret',
  'project-content.project-content-updates.edit-update': 'Rediger',
  "project-content.project-content-updates.for-date'": 'til {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Seneste opdatering',
  'project-content.project-content-updates.missed-update-message': 'Der blev ikke slået nogen opdatering op',
  'project-content.project-content-updates.new-due-date': 'Ny deadline',
  'project-content.project-content-updates.new-state': 'Ny status',
  'project-content.project-content-updates.no-updates-description':
    'Der er endnu ingen opdateringer til dette projekt.',
  'project-content.project-content-updates.off-track': 'På vildspor',
  'project-content.project-content-updates.old-due-date': 'Gammel deadline',
  'project-content.project-content-updates.old-state': 'Gammel status',
  'project-content.project-content-updates.on-track': 'På ret kurs',
  'project-content.project-content-updates.paused': 'Sat på pause',
  'project-content.project-content-updates.pending': 'Afventer',
  'project-content.project-content-updates.previous-updates-title': 'Tidligere opdateringer',
  'project-content.project-content-updates.share-update': 'Del',
  'project-content.project-content-updates.status-changed': 'Status ændret',
  'project-content.project-content-updates.write-update-button': 'Skriv en opdatering',
  'project-update-composer.modal-post-button-label': 'Udgiv opdatering',
  'project-update-composer.modal-title': 'Lav et opslag med din opdatering',
};
